import styled from 'styled-components'
import { styled as muiStyled } from '@mui/material'

export const SupportHeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px 12px 16px;
  background: linear-gradient(135deg, rgba(67, 56, 202, 0.85) 0%, rgba(79, 70, 229, 0.85) 50%, rgba(99, 102, 241, 0.85) 100%);
  backdrop-filter: blur(24px) saturate(200%);
  -webkit-backdrop-filter: blur(24px) saturate(200%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 
    0 4px 24px rgba(67, 56, 202, 0.15),
    0 1px 0 rgba(255, 255, 255, 0.1) inset;
  position: sticky;
  top: 0;
  z-index: 1000;
  color: rgba(255, 255, 255, 0.98);
  min-height: 60px;
  transition: opacity 0.3s ease, transform 0.3s ease;
  box-sizing: border-box;
  gap: 16px;

  /* Glass effect overlay - subtle gradient */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%);
    pointer-events: none;
    border-radius: 0;
  }

  /* Subtle top highlight */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    pointer-events: none;
  }

  @media (min-width: 900px) {
    padding: 14px 24px 14px 20px;
    min-height: 64px;
  }

  @media (max-width: 768px) {
    padding: 10px 12px 10px 10px;
    min-height: 52px;
    gap: 12px;
  }
`

export const SupportHeaderGreeting = styled.div`
  color: inherit;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  font-style: normal;
  line-height: 1.25;
  font-size: ${(props) => (props?.main ? '1.125rem' : '0.6875rem')};
  font-weight: ${(props) => (props?.main ? '700' : '500')};
  letter-spacing: ${(props) => (props?.main ? '-0.02em' : '0.02em')};
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 1;
  margin: 0;
  padding: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${(props) =>
    props?.main
      ? `
    line-height: 1.2;
    letter-spacing: -0.02em;
  `
      : `
    opacity: 0.92;
    margin-top: 2px;
    letter-spacing: 0.02em;
  `}

  @media (min-width: 600px) {
    font-size: ${(props) => (props?.main ? '1.375rem' : '0.75rem')};
    white-space: normal;
  }

  @media (min-width: 900px) {
    font-size: ${(props) => (props?.main ? '1.5rem' : '0.8125rem')};
  }
`

/** Wrapper for nav buttons (Home, Back) to group them */
export const SupportHeaderNavBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`

/** Wrapper for page title; takes remaining space and separates from nav */
export const SupportHeaderTitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  flex: 1;
  padding-left: 12px;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  margin-left: 4px;

  @media (max-width: 599px) {
    padding-left: 10px;
    margin-left: 2px;
  }
`


export const SupportHeaderLinkText = styled.div`
  color: #767676;
  font-family: Outfit;
  font-style: normal;
  line-height: normal;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  margin-right: 20px;

  &:hover {
    color: #000;
  }

  @media (max-width: 800px) {
    display: none;
  }
`

export const SupportHeaderStatusOfUpdates = muiStyled('div')(
  ({ theme, customColor }) =>
    `
    background: ${customColor ? customColor : '#e4f6d4'};
    padding: 5px 0;
    display: flex;
    justify-content: center;
    font-weight: 600;
    color: #000;
    font-size: 14px;
    gap: 8px;
    font-family: Outfit;
    align-items: center;
    flex-wrap: wrap;
    @media (min-width: 768px) {
        gap: 15px;
    }
`,
)
